module.exports = __webpack_public_path__ + "static/media/EmailIcon.aa573b75.svg";